var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "15px",
    viewBox: "0 0 18 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "email") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Pesquisa",
    transform: "translate(-592.000000, -6155.000000)",
    stroke: "",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21-Copy-2",
    transform: "translate(162.000000, 5902.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(431.000000, 254.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,13 C1.6,13 0,11.8529412 0,9.17647059 L0,3.82352941 C0,1.14705882 1.6,0 4,0 L12,0 C14.4,0 16,1.14705882 16,3.82352941 L16,9.17647059 C16,11.8529412 14.4,13 12,13 L4,13 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,4.20588235 L9.49599609,6.11764706 C8.67199612,6.74470588 7.31999607,6.74470588 6.49599609,6.11764706 L4,4.20588235",
    id: "Vector"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2f36a45a2226948e22e813dc61c5c5aa.svg";
export { ForwardRef as ReactComponent };